// This blue button has fixed width
export function Button({ onClick, disabled, children }: { onClick: any, children: any, disabled?: any }) {
    return (
        <button onClick={onClick}
            className={`py-1 px-2 w-20 rounded-md shadow-md transition-all duration-300 ease-in-out text-xs
        ${disabled
                    ? 'bg-gray-200 cursor-not-allowed text-gray-600'
                    : 'bg-gradient-to-r from-blue-600 to-blue-500 text-white hover:from-blue-700 hover:to-blue-600 active:shadow-inner'
                }
            
        `}
            disabled={disabled}>
            {children}
        </button>
    )
}

export function Button2({ onClick, children }: { onClick: any, children: any }) {
    return (
        <button onClick={onClick} className="text-xs shadow shadow-gray-200 py-1 px-3 text-gray-600 border rounded-lg hover:bg-gray-100  ">
            {children}
        </button>
    )
}

// This blue button has dynamic width
export function BlueButton({ onClick, disabled, children }: {
    onClick: any, children: any,
    disabled?: any
}) {
    return (
        <button onClick={onClick}
            className={`py-1 px-2 rounded-md shadow-md transition-all duration-300 ease-in-out 
                text-xs bg-gradient-to-r from-blue-600 to-blue-500 text-white 
                hover:from-blue-700 hover:to-blue-600 active:shadow-inner`}
            disabled={disabled}>
            {children}
        </button>
    )
}

export function SmallButton({ onClick, children }: { onClick: any, children: any }) {
    return (
        <button onClick={onClick} className="text-xs shadow shadow-gray-200 py-1 px-3 
        text-gray-600 border rounded-lg hover:bg-gray-100  ">
            {children}
        </button>
    )
}

export function TerminalButton({ processing, onClick, children }: {
    processing: boolean, onClick: any,
    children: any
}) {
    return (
        <button
            disabled={processing}
            onClick={onClick}
            className={`font-medium text-xs mt-4 w-full bg-gradient-to-r from-blue-600 to-blue-500  text-white py-2 px-4 rounded-md ${!processing && "hover:bg-blue-700"}
                                        focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors 
                                        duration-300`}>
            {children}
        </button>
    )
}

export function TerminalButton2({ onClick, children }: {
    onClick: any,
    children: any
}) {
    return (
        <button
            onClick={onClick}
            className="font-medium text-xs mt-2 w-full text-gray-500 hover:text-gray-700 py-2 px-4 rounded-md
                                border border-gray-500 hover:bg-gray-200
                               transition-colors 
                                duration-300">
            {children}
        </button>
    )
}

export function TerminalButton3({ onClick, children, selected }: {
    onClick: any,
    children: any,
    selected: boolean
}) {
    return (
        <div onClick={onClick} className={"font-medium flex flex-col items-center shadow-md py-1 rounded-lg w-28 border  cursor-pointer " +
            (selected ? "border-blue-500 shadow-blue-200" : "shadow-gray-300 hover:shadow-gray-400 border-gray-200")} >
            {children}
        </div>
    )
}